import api from '@/api/api'

const state = {
    roles: []
};

const getters = {
    getRoles: state => state.roles
};

const mutations = {
    EMPTY_ROLES(state) {
        state.roles = []
    },
    FETCH_ROLE(state, role) {
        state.roles.push(role)
    }
};

const actions = {
    async fetchRoles({commit}) {
        commit('EMPTY_ROLES');
        api.fetchRoles().then(res => {
            res.data.data.forEach(item => {
                commit('FETCH_ROLE', item);
            })
        })
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/roles.js